import { Pathname, Search } from 'history'
import { Channel } from '@at/sauron-platform-core'
import { getChannelSingular } from '@at/formatter-utils/lib/channel-utils/channel.util'
import { parse } from 'query-string'
import { useChannel } from '../hooks/use-abtest.hook'

export const searchUrlFromAdvertisingLocation = (advertisingLocation: string): string => {
    switch (advertisingLocation) {
        case 'at_cars':
            return '/car-search'
        case 'at_vans':
            return '/van-search'
        case 'at_bikes':
            return '/bike-search'
        case 'at_cycles':
            return '/electric-bike-search'
        case 'at_caravans':
            return '/caravan-search'
        case 'at_motorhomes':
            return '/motorhome-search'
        default:
            return '/car-search'
    }
}

export const channelFromAdvertisingLocation = (search: Search): Channel => {
    const advertisingLocation = parse(search)['advertising-location']
    switch (true) {
        case advertisingLocation?.includes('at_cars'):
            return Channel.cars
        case advertisingLocation?.includes('at_vans'):
            return Channel.vans
        case advertisingLocation?.includes('at_bikes'):
            return Channel.bikes
        case advertisingLocation?.includes('at_cycles'):
            return Channel.cycles
        case advertisingLocation?.includes('at_caravans'):
            return Channel.caravans
        case advertisingLocation?.includes('at_motorhomes'):
            return Channel.motorhomes
        default:
            return Channel.cars
    }
}

export const profileAdvertisingLocationFromChannel = (channel: Channel): string => {
    switch (channel) {
        case Channel.cars:
            return 'at_profile_cars'
        case Channel.vans:
            return 'at_profile_vans'
        case Channel.bikes:
            return 'at_profile_bikes'
        case Channel.cycles:
            return 'at_profile_cycles'
        case Channel.caravans:
            return 'at_profile_caravans'
        case Channel.motorhomes:
            return 'at_profile_motorhomes'
        case Channel.trucks:
            return 'at_profile_trucks'
        case Channel.plant:
            return 'at_profile_plant'
        case Channel.farm:
            return 'at_profile_farm'
        default:
            return 'at_profile_cars'
    }
}

export const getChannelFromPathnameOrAdvertisingLocation = (pathname: Pathname, search: Search): Channel => {
    switch (true) {
        case pathname.includes('caravan'):
            return Channel.caravans
        case pathname.includes('motorhome'):
            return Channel.motorhomes
        case pathname.includes('car'):
            return Channel.cars
        case pathname.includes('van'):
            return Channel.vans
        case pathname.includes('truck'):
            return Channel.trucks
        case pathname.includes('electric-bike'):
            return Channel.cycles
        case pathname.includes('bike'):
            return Channel.bikes
        case pathname.includes('plant'):
            return Channel.plant
        case pathname.includes('farm'):
            return Channel.farm
        default:
            return channelFromAdvertisingLocation(search)
    }
}

export const getChannelFromPathname = (pathname: Pathname): Channel => {
    switch (true) {
        case pathname.includes('caravan'):
            return Channel.caravans
        case pathname.includes('motorhome'):
            return Channel.motorhomes
        case pathname.includes('car'):
            return Channel.cars
        case pathname.includes('van'):
            return Channel.vans
        case pathname.includes('truck'):
            return Channel.trucks
        case pathname.includes('electric-bike'):
            return Channel.cycles
        case pathname.includes('bike'):
            return Channel.bikes
        case pathname.includes('plant'):
            return Channel.plant
        case pathname.includes('farm'):
            return Channel.farm
        default:
            return Channel.cars
    }
}

export const getSearchResultsRoot = (channel: Channel): string => {
    switch (channel) {
        case Channel.cycles: {
            return 'electric-bike-search'
        }
        default: {
            return `${getChannelSingular(channel)}-search`
        }
    }
}

export const useIsLeisureOrTPF = () => {
    const channel = useChannel()
    return (
        channel === Channel.trucks ||
        channel === Channel.farm ||
        channel === Channel.plant ||
        channel === Channel.motorhomes ||
        channel === Channel.caravans
    )
}

export type ChannelSearchTypeKey = Channel | 'cars-leasing' | 'vans-leasing'

export const getChannelSearchTypeKey = (channel: Channel, isLeasing: boolean): ChannelSearchTypeKey => {
    return isLeasing ? (`${channel}-leasing` as ChannelSearchTypeKey) : channel
}
